import axios from 'axios'
import settings from '../../settings'

const Tv = {
  namespaced: true,
  state: () => ({
    packages: [],
    loading: false
  }),
  mutations: {
    updatePackagesState(state, data) {
      state.packages = data;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    fetchPackages({ commit }, { page = 1, query = null }) {
      commit('setLoading', true);
      commit('updatePackagesState', []);
      return axios.get(`${settings.apiUrl}/v2/tv/packages?page=${page}&q=${query}`).then(res => {
        commit('updatePackagesState', res.data.data);
        commit('setLoading', false);
        return res.data.data;
      }).catch(err => {
        commit('setLoading', false);
        throw err;
      });
    },
    updatePackagesSequence({ dispatch }, { data }) {
      const sec = new FormData();
      sec.append('data', JSON.stringify(data));
      return axios.post(`${settings.apiUrl}/v2/tv/packages/sequence`, sec).then(res => {
        dispatch('fetchPackages', { page: 1 });
        return res;
      });
    },
    updateChannelsSequence({ dispatch }, { data, package_id }) {
      const sec = new FormData();
      sec.append('data', JSON.stringify(data));
      sec.append('package_id', package_id);
      return axios.post(`${settings.apiUrl}/v2/tv/channels/sequence`, sec).then(res => {
        return res;
      });
    },
    toggleChannelStatus({ dispatch }, { channel_id, status }) {
      const data = new FormData();
      data.append('id', channel_id);
      data.append('status', status);
      return axios.post(`${settings.apiUrl}/v2/tv/channels/toggle-status`, data).then(res => {
        return res;
      });
    }
  },

  getters: {
    isLoading: state => state.loading,
    allPackages: state => state.packages
  }
}

export default Tv;